import type { ApiQuestionSetting } from '../../../../internalTypes';

export function extractDefaultOptionIds(
  configs: ApiQuestionSetting[],
  validOptionIds?: string[]
): string[] | undefined {
  const defaultAnswerConfig = configs.find(c => c.key === 'DEFAULT_ANSWER');
  if (defaultAnswerConfig?.value?.[0]?.toLowerCase() !== 'true') {
    return undefined;
  }

  const defaultAnswersConfig = defaultAnswerConfig.childConfigs?.find(
    c => c.key === 'DEFAULT_ANSWERS'
  );
  const ids = defaultAnswersConfig?.value?.filter(Boolean) ?? [];
  if (ids.length === 0) {
    return undefined;
  }

  if (validOptionIds && validOptionIds.length > 0) {
    const validSet = new Set(validOptionIds);
    const filtered = ids.filter(id => validSet.has(id));
    return filtered.length > 0 ? filtered : undefined;
  }

  return ids;
}
